export function isValidEvent(event: PointerEvent): boolean {
  if (event.button > 0) {
    return false
  }

  return true
}
